/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-test-threshold.reducer';

export const DiaglabTestThresholdDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabTestThresholdEntity = useAppSelector(state => state.diaglabTestThreshold.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabTestThresholdDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.detail.title">DiaglabTestThreshold</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabTestThresholdEntity.id}</dd>
          <dt>
            <span id="sourceStatusCode">
              <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.sourceStatusCode">Source Status Code</Translate>
            </span>
          </dt>
          <dd>{diaglabTestThresholdEntity.sourceStatusCode}</dd>
          <dt>
            <span id="targetStatusCode">
              <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.targetStatusCode">Target Status Code</Translate>
            </span>
          </dt>
          <dd>{diaglabTestThresholdEntity.targetStatusCode}</dd>
          <dt>
            <span id="threshold">
              <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.threshold">Threshold</Translate>
            </span>
          </dt>
          <dd>{diaglabTestThresholdEntity.threshold}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabTestThresholdEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabTestThresholdEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diaglabTestThresholdEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabTestThresholdEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diaglabTestThresholdEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diaglabTestThresholdEntity.diagLab ? diaglabTestThresholdEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.panel">Panel</Translate>
          </dt>
          <dd>{diaglabTestThresholdEntity.panel ? diaglabTestThresholdEntity.panel.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.testItem">Test Item</Translate>
          </dt>
          <dd>{diaglabTestThresholdEntity.testItem ? diaglabTestThresholdEntity.testItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.radiologyTest">Radiology Test</Translate>
          </dt>
          <dd>{diaglabTestThresholdEntity.radiologyTest ? diaglabTestThresholdEntity.radiologyTest.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-test-threshold" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-test-threshold/${diaglabTestThresholdEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabTestThresholdDetail;
